import { render } from "./BaseFormSectionHeader.vue?vue&type=template&id=18e4afc1"
import script from "./BaseFormSectionHeader.vue?vue&type=script&lang=js"
export * from "./BaseFormSectionHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/megaluzz-client/megaluzz-client/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__